import { useContext, useEffect, useMemo, useRef, useState } from "react"
import useModal from "../hooks/useModal"
import Button from "./form-controls/Button"
import Input from "./form-controls/Input"
import { useFieldArray, useForm } from "react-hook-form"
import { AppContext } from "../context/AppContext"
import { ReportService } from "../services/ReportsService"
import { useCurrentAccount } from "../hooks/useCurrentAccount"
import { AlertService } from "../services/Alert"
import useRequest from "../hooks/useRequest"
import Loader from "./Loader"
import { useTranslation } from "react-i18next"


function ModalCustomerInfo() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    
    const {call, isRequesting} = useRequest();

    const { showCustomerDetail, setShowCustomerDetail } = useContext(AppContext);

    const modalRef = useRef<HTMLDivElement>(null)

    useModal(modalRef, showCustomerDetail.show)

    const [customer, setCustomer] = useState(null)

    const defaultValues = {
        nombre: '',
        fields: [],
    }
    const { control, register, handleSubmit, setValue, reset, formState: { errors, isValid, isSubmitting, submitCount } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const fieldsArray = useFieldArray({
        control, 
        name: 'fields',
    });

    const initialsCustomer = useMemo(() => {
        if(!customer?.name) return ;

        return customer?.name[0].toUpperCase()
    }, [customer])
    
    const handleStatusCustomer = async() => {
        const title = customer.blocked ? 'Desbloquear cliente': 'Bloquear cliente';
        const message = customer.blocked ? '¿Estas seguro de querer desbloquear a este cliente?': '¿Estas seguro de querer bloquear a este cliente?';

        await AlertService.warning(title, message, async () => {
            try {
                if(customer.blocked) {
                    await ReportService.unblockCustomer(account.id, showCustomerDetail.account_client_id)
                } else {
                    await ReportService.blockCustomer(account.id, showCustomerDetail.account_client_id)
                }

                await getCustomerInfo()
                
                AlertService.toastSuccess('Se cambió correctamente el estatus del cliente.')
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al cambiar el estatus del cliente, intenta nuevamente')
            }
        });
    }
    
    const getCustomerInfo = async () => {
        const { data } = await call(() => ReportService.getCustomerInfo(account.id, showCustomerDetail.account_client_id));
        data.name = (data.name == '' || data.name) ? data.name : t('reports.tickets.modal-customer.new-customer');
        setValue('nombre', data.name);
        setCustomer(data)

        if(data.data) {
            let {...staticFields} = data.data;
        
            fieldsArray.remove()
            for (const key of Object.keys(staticFields)) {
                fieldsArray.append({
                    key,
                    value: staticFields[key]
                })
            }
        }
        setTimeout(() => document.getElementsByClassName('modal')[0].scroll(0,0), 100)
    }

    const addField = () => {
        fieldsArray.append({
            key: '',
            value: ''
        })
    }

    const deleteField = (index) => {
        fieldsArray.remove(index)
    }

    const submit = async(data) => {
        try {
            let info = {
                // id: customer.data.id, 
                // numero: customer.data.numero, 
            }
            for (const field of data.fields) {
                info[field.key] = field.value
            }
    
            await ReportService.updateCustomerInfo(account.id, data.nombre, showCustomerDetail.account_client_id, JSON.stringify(info))

            getCustomerInfo();
            
            AlertService.toastSuccess('Se guardó correctamente la información del cliente.')
            setShowCustomerDetail(s => ({ ...s, show: false }))
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la información del cliente, intenta nuevamente')
        }
    }

    useEffect(() => {
        if(showCustomerDetail.account_client_id && showCustomerDetail.show) {
            getCustomerInfo();
        }
    }, [showCustomerDetail.account_client_id, showCustomerDetail.show])

    useEffect(() => {
        if(!showCustomerDetail.show) {
            reset(defaultValues);
            setCustomer(null)
        }
    }, [showCustomerDetail.show])
    
    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-400':''},[isRequesting]);
    return (
        <div className="modal fade" ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false" >
            <div className="modal-dialog " role="document">

                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        {/* <h4 className="modal-title" >Editar cliente</h4> */}
                        <button type="button" className="btn-close" onClick={() => setShowCustomerDetail(s => ({ ...s, show: false }))}></button>
                    </div>
                    <div className={`relative ${heightRequesting}`}>
                    {
                        isRequesting ? <Loader/> :
                                <>
                                    <div className="modal-body">

                                        <div className="bg-white mb-5 ">
                                            <div className="d-flex align-items-center">
                                                <span className="avatar-xl avatar-primary avatar-circle me-3">
                                                    <span className="avatar-initials">{initialsCustomer}</span>
                                                </span>
                                                <div>
                                                    <h3 className="m-0 mb-2">{customer?.number}</h3>
                                                    <button onClick={handleStatusCustomer} className="btn btn-link p-0">{customer?.blocked ? <i className="bi-lock"></i> : <i className="bi-unlock"></i>} {customer?.blocked ? t('reports.tickets.modal-customer.unblock-btn') : t('reports.tickets.modal-customer.block-btn')} {t('reports.tickets.modal-customer.customer')}</button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <h5 className=" mb-0" >{t('reports.tickets.modal-customer.info-title')}</h5>
                                            <p className=" mt-1 mb-2">
                                            {t('reports.tickets.modal-customer.info-description')}
                                            </p>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="inputGroupMergeFullName" className="form-label">{t('reports.tickets.modal-customer.name-label')}</label>

                                            <div className={`input-group input-group-merge` + (errors.nombre ? ' is-invalid-custom ' : '')}>
                                                <div className="input-group-prepend input-group-text"><i className="bi-person-square"></i></div>
                                                <input type="text" className={`form-control `}   {...register('nombre', { required: true })} />
                                            </div>
                                        </div>

                                        {
                                            fieldsArray.fields.map((field, index) => (
                                                <div className="mb-3 d-flex align-items-end" key={field.id}>
                                                    <div className="flex-grow-1">
                                                        <label className="form-label" >{t('reports.tickets.modal-customer.field-label')}</label>
                                                        <input type="text" className={`form-control ` + (errors.fields?.[index]?.['key'] ? ' is-invalid ' : '')}    {...register(`fields.${index}.key`, { required: true })} />
                                                        {/* <Input label='Campo *' sizeClass={''} errors={errors.fields?.[index]?.['key']} {...register(`fields.${index}.key`, { required: true })} /> */}
                                                    </div>
                                                    <div className=" flex-grow-1 mx-3">
                                                        <label className="form-label" >{t('reports.tickets.modal-customer.value-label')}</label>
                                                        <input type="text" className={`form-control ` + (errors.fields?.[index]?.['value'] ? ' is-invalid ' : '')}    {...register(`fields.${index}.value`, { required: true })} />
                                                        {/* <Input label='Valor *' sizeClass={''} errors={errors.fields?.[index]?.['value']} {...register(`fields.${index}.value`, { required: true })} /> */}
                                                    </div>

                                                    <button className="btn btn-soft-danger ms-auto" type="button" onClick={() => deleteField(index)}><i className="bi-x-lg"></i></button>
                                                </div>
                                            ))
                                        }

                                        <div className="mb-3 d-grid">
                                            <button type="button" className="btn btn-soft-primary " onClick={addField}><i className="bi bi-plus-lg"></i> {t('reports.tickets.modal-customer.add-field')}</button>
                                        </div>

                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-white btn-sm" onClick={() => setShowCustomerDetail(s => ({ ...s, show: false }))}>{t('btn-cancel')}</button>
                                        <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t('btn-save')}</Button>
                                    </div>
                                </>
                    }
                    </div>
                </div>

            </div>
        </div>
    )
}
export default ModalCustomerInfo